export type ManualRatingData = {
  ratingValue: number;
  reviewUrl: string;
};

export type ResolvedRating = {
  ratingValue: number;
  reviewUrl: string;
};

export const isValidRating = (value: unknown): value is number =>
  typeof value === "number" &&
  Number.isFinite(value) &&
  value >= 0 &&
  value <= 5;

export const isValidManualData = (
  data?: ManualRatingData,
): data is ManualRatingData =>
  !!data &&
  Number.isFinite(data.ratingValue) &&
  data.ratingValue > 0 &&
  data.ratingValue <= 5 &&
  typeof data.reviewUrl === "string" &&
  data.reviewUrl.length > 0;

export const isValidG2ProductId = (id: unknown): id is string =>
  typeof id === "string" &&
  id.length > 0 &&
  id.length <= 256 &&
  /^[a-z0-9-]+$/.test(id);
